const orderApprovePageControl = {
  // 访问许可 - 如果访问路径中没有参数，则提示错误
  accessAllowed: false,
  // 详情页上面所有的解密小眼睛，显示隐藏控制，与encryptionType对应
  eyes: {
    proposer: {idno: true, mobile: true}, // 申请人： 证件 | 手机号
    eContactMobile: true, // 紧急联系人手机号
    eContactsMobile: true, // 紧急联系人2手机号
    carIdentify: true, // 车辆识别代号
    carSaleIdno: true, // 二手车卖方身份证号
    repAccountIdno: true, // 还款人证件号码
    repAccountNo: true, // 还款借记卡号
    repAccountMobile: true, // 还款人银行卡预留手机
    guarantee: {idno: true, mobile: true}, // 担保人： 证件 | 手机号
    relative: {idno: true, mobile: true}, // 配偶： 证件 | 手机号
    recAccountNo: true, // 收款借记卡号
    recAccountCard: true // 收款人证件号码
  },
  // 所有变量当前状态
  current: {
    operateType: 0, // 操作类型
    operateTypePreview: false, // 当前操作类型为预览
    operateTypeApprove: false, // 当前操作类型为审批
    operateTypeModify: false, // 当前操作类型为编辑
    identity: 0, // 身份
    identityApprover: false, // 当前身份为审批者
    approvalStep: 0, // 审批阶段 - 仅用于init中逻辑判断，其他逻辑均用下边的Boolean类型做判断
    approvalStepFirst: false, // 当前审批阶段为初审
    approvalStepReview: false, // 当前审批阶段为复审
    approvalStepFinal: false, // 当前审批阶段为终审
    approvalStepReconsider: false, // 当前审批阶段为终审(复议)
    approvalStepContract: false, // 当前审批阶段为签约审
    approvalStepGps: false, // 当前审批阶段为GPS审
    approvalStepMortgage: false, // 当前审批阶段为先放款抵押审批
    approvalStepAfterFinal: false, // 当前阶段在终审之后
    forSearch: false, // 是否综合查询
    isCompanyLicense: true, // 当前车牌类型是否为公牌
    isMarried: true, // 申请人是否已婚
    hasGuaranteeInfo: true // 申请人是否有担保人
  },
  // 进入页面者角色
  identity: {
    approver: 0, // 审批人员
    operator: 1 // 运营人员
  },
  // 操作类型
  operateType: {
    preview: 0, // 预览
    modify: 1, // 修改
    approve: 2 // 审批
  },
  // 审批阶段
  approveStep: {
    first: 0, // 初审阶段
    review: 1, // 复审阶段
    final: 2, // 终审阶段
    reconsider: 22, // 终审阶段(复议)
    contract: 3, // 签约阶段
    mortgage: 4, // 先放款抵押审批
    gps: 90, // GPS审批阶段
    for_search: 91, // 代指综合查询
    after: 100, // 之后的阶段
    names: [{value: '初审阶段'}, {value: '复审阶段'}, {value: '终审阶段'}, {value: '签约阶段'}, {value: '抵押阶段'}]
  }
}

export {
  orderApprovePageControl
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.control.js